module.exports = __webpack_public_path__ + "img/wheelbg.6a4fd571.png";